module.exports = __webpack_public_path__ + "img/ceaslov-1640-fila-18v-fila-19r-big.d60a6632.jpg";